import React, { HTMLAttributes, useState } from "react";

// Import Swiper React components
import { Swiper, SwiperSlide, type SwiperClass } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

// import required modules
import { Controller } from "swiper/modules";
import ListPoint from "../../../components/atoms/listPoint";

interface IContactUsSwiper {}

export const CONTACT_US_LIST_TEXT = [
  {
    chinese_text:
      "Asgard EV 可以為你的物業提供電動車充電站的解決方案，我們提供產品或租賃計劃方案",
    english_text:
      "Asgard EV can provide solutions for EV charging stations for your property. We offer both product purchase and leasing plan options.",
  },
  {
    chinese_text:
      "Asgard EV 為各屋苑提供電動車充電站的解決方案，而我們的方案可以為你帶來額外收入",
    english_text:
      "Asgard EV provides electric vehicle charging station solutions for residential estates, and our plans can generate additional income for you.",
  },
  {
    chinese_text: `Asagrd EV 能為電動車車主提供"即插即充"功能而無需使用應用程式，我們的開發團隊能為企業提供完善的售後充電配套支援服務`,
    english_text: `Asgard EV offers owners a "Plug & Charge" feature without the need for an app. Our development team provides comprehensive after-sales support services for your company.`,
  },
];

export const PAGINATION_LIST = [
  {
    chinese_text: "物業擁有人",
    english_text: "Prop Owner",
  },
  {
    chinese_text: "物業管理公司",
    english_text: "Prop Mgmt Co",
  },
  {
    chinese_text: "汽車銷售商",
    english_text: "Car Dealership",
  },
];

type TContactUsSwiperProps = IContactUsSwiper & HTMLAttributes<HTMLDivElement>;

const ContactUsSwiper: React.FC<TContactUsSwiperProps> = (props) => {
  //@ts-ignore
  const [controlledSwiper, setControlledSwiper] = useState<SwiperClass>(null);
  const [activeIndex, setActiveIndex] = useState(0);

  const handleSlideChange = () => {
    setActiveIndex(controlledSwiper?.activeIndex || 0);
  };

  const CustomPagination = () => {
    return (
      <div className="flex flex-row justify-evenly items-center gap-2">
        {PAGINATION_LIST.map((text, index) => {
          return (
            <React.Fragment key={index}>
              <div
                className={`flex flex-col font-bold text-center cursor-pointer hover:text-mainYellow ${
                  activeIndex === index ? "text-white" : "text-secondaryDark"
                }`}
                onClick={() => controlledSwiper.slideTo(index)}
              >
                <span className="text-base laptop:text-2xl">
                  {text.chinese_text}
                </span>
                <span className="text-sm laptop:text-base">
                  {text.english_text}
                </span>
              </div>

              {/* Add a divider except after the last item */}
              {index < PAGINATION_LIST.length - 1 && (
                <div className="w-[1px] h-full bg-gray-400"></div>
              )}
            </React.Fragment>
          );
        })}
      </div>
    );
  };

  return (
    <div className="flex flex-col gap-8 mb-3">
      <CustomPagination />
      <Swiper
        modules={[Controller]}
        controller={{ control: controlledSwiper }}
        onSwiper={setControlledSwiper}
        onSlideChange={handleSlideChange}
        className="flex flex-1 laptop:w-[500px] h-[140px] mx-0"
      >
        {CONTACT_US_LIST_TEXT.map((text, index) => {
          return (
            <SwiperSlide
              className="flex flex-row text-mainYellow gap-6"
              key={index}
            >
              <ListPoint />
              <div className="flex flex-col gap-2 text-xs laptop:text-base">
                <span className="font-bold">{text.chinese_text}</span>
                <span className="laptop:leading-6 ">{text.english_text}</span>
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
};

export default ContactUsSwiper;
